import { createContext, useContext, useEffect, useMemo, useState } from "react";
import { api, sessionMarker } from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    localStorage.removeItem("dcn_token");
    if (!sessionMarker.exists()) {
      setUser(false);
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => {
        sessionMarker.clear();
        setUser(false);
      })
      .finally(() => setLoading(false));
  }, []);

  const value = useMemo(() => {
    const login = async (email, password) => {
      const { data } = await api.post("/auth/login", { email, password });
      sessionMarker.set();
      setUser(data.user);
      return data.user;
    };
    const logout = async () => {
      try {
        await api.post("/auth/logout");
      } catch {
        // session already ended server-side — safe to ignore
      }
      sessionMarker.clear();
      setUser(false);
    };
    return { user, setUser, loading, login, logout };
  }, [user, loading]);

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
